// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `grid-data mat-sidenav-container {
  width: 100%;
  height: 100%;
}
grid-data mat-sidenav-container mat-sidenav {
  width: 70% !important;
  min-width: 70% !important;
  max-width: 70% !important;
}
grid-data mat-sidenav-container #board {
  display: flex;
  flex-direction: column !important;
  height: 100%;
}
grid-data mat-sidenav-container #board > .header {
  position: relative;
  min-height: 72px;
  height: 72px;
  background-image: none;
  z-index: 49;
}
grid-data mat-sidenav-container #board > .header .header-content .header-boards-button {
  margin: 0;
}
grid-data mat-sidenav-container #board > .header .header-content .header-board-name {
  font-size: 16px;
}
grid-data mat-sidenav-container #board > .header .header-content .header-board-name .board-subscribe {
  margin-right: 8px;
}
grid-data mat-sidenav-container #board > .header .header-content .header-board-name .editable-buttons mat-icon {
  color: #FFFFFF !important;
}
grid-data mat-sidenav-container #board > .header .header-content .right-side > .mat-mdc-button:last-child {
  margin-right: 0;
}
grid-data mat-sidenav-container #board > .header .quick-search {
  content: "";
  cursor: pointer;
  position: absolute;
  top: 100%;
  right: 2%;
  margin: -10 auto;
  width: 0;
  height: 0;
  border-left: solid 20px transparent;
  border-right: solid 20px transparent;
  z-index: 1;
}
grid-data mat-sidenav-container #board > .header .quick-search mat-icon.add {
  bottom: 0;
  position: absolute;
  left: -12px;
}
grid-data mat-sidenav-container #board > .header .quick-search mat-icon.minimize {
  bottom: 9px;
  position: absolute;
  left: -12px;
}
grid-data mat-sidenav-container #board > .header accounts-quick-search {
  position: absolute;
  top: 100%;
  width: 100%;
  right: 0;
}
grid-data mat-sidenav-container #board > .header owners-quick-search {
  position: absolute;
  top: 100%;
  width: 100%;
  right: 0;
}
grid-data mat-sidenav-container #board #board-selector {
  position: absolute;
  top: 96px;
  right: 0;
  left: 0;
  height: 192px;
  z-index: 48;
  padding: 24px;
  opacity: 1;
}
grid-data mat-sidenav-container #board #board-selector .board-list-item {
  width: 128px;
  height: 192px;
  padding: 16px;
  cursor: pointer;
  position: relative;
}
grid-data mat-sidenav-container #board #board-selector .board-list-item .board-name {
  text-align: center;
  padding: 16px 0;
}
grid-data mat-sidenav-container #board #board-selector .board-list-item .selected-icon {
  position: absolute;
  top: 0;
  left: 50%;
  width: 32px;
  height: 32px;
  margin-left: -16px;
  border-radius: 50%;
  text-align: center;
  color: white;
}
grid-data mat-sidenav-container #board #board-selector .board-list-item .selected-icon i {
  line-height: 32px !important;
}
grid-data mat-sidenav-container #board #board-selector .board-list-item.add-new-board {
  opacity: 0.6;
}
grid-data mat-sidenav-container #board .board-content-wrapper {
  position: relative;
}
grid-data mat-sidenav-container #board .board-content-wrapper .board-content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  overflow-y: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
grid-data mat-sidenav-container #board .board-content-wrapper .board-content .list-sortable-placeholder {
  background: rgba(0, 0, 0, 0.06);
  margin-right: 24px;
}
grid-data mat-sidenav-container #board .board-content-wrapper .board-content .new-list-wrapper {
  width: 344px;
  min-width: 344px;
  max-width: 344px;
  padding-right: 24px;
}
grid-data .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
grid-data .example-container {
  width: 400px;
  max-width: 100%;
  margin: 0 25px 25px 0;
  display: inline-block;
  vertical-align: top;
}
grid-data .example-list {
  border: solid 1px #ccc;
  min-height: 60px;
  background: white;
  border-radius: 4px;
  overflow: hidden;
  display: block;
}
grid-data .example-box {
  padding: 20px 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
grid-data .cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
grid-data .cdk-drag-placeholder {
  opacity: 0;
}
grid-data .cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
grid-data .example-box:last-child {
  border: none;
}
grid-data .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}`, "",{"version":3,"sources":["webpack://./src/app/main/master-data/grid-boards/grid-data/grid-data.component.scss"],"names":[],"mappings":"AAEI;EACI,WAAA;EACA,YAAA;AADR;AAGQ;EACI,qBAAA;EACA,yBAAA;EACA,yBAAA;AADZ;AAIQ;EACI,aAAA;EACA,iCAAA;EACA,YAAA;AAFZ;AAIY;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAFhB;AAMoB;EACI,SAAA;AAJxB;AAOoB;EACI,eAAA;AALxB;AAOwB;EACI,iBAAA;AAL5B;AAU4B;EACI,yBAAA;AARhC;AAewB;EACI,eAAA;AAb5B;AAmBgB;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,UAAA;AAjBpB;AAoBwB;EACI,SAAA;EACA,kBAAA;EACA,WAAA;AAlB5B;AAqBwB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;AAnB5B;AAyBgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;AAvBpB;AA0BgB;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,QAAA;AAxBpB;AA4BY;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AA1BhB;AA4BgB;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;AA1BpB;AA4BoB;EACI,kBAAA;EACA,eAAA;AA1BxB;AA6BoB;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AA3BxB;AA6BwB;EACI,4BAAA;AA3B5B;AA+BoB;EACI,YAAA;AA7BxB;AAkCY;EACI,kBAAA;AAhChB;AAkCgB;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;AAhCpB;AAkCoB;EACI,+BAAA;EACA,kBAAA;AAhCxB;AAmCoB;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAjCxB;AAyCI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAvCR;AAyCI;EACI,YAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,mBAAA;AAvCR;AA0CM;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAxCR;AA2CM;EACE,kBAAA;EACA,6BAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAzCR;AA4CM;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AA1CR;AA+CM;EACE,UAAA;AA7CR;AAgDM;EACE,sDAAA;AA9CR;AAiDM;EACE,YAAA;AA/CR;AAkDM;EACE,sDAAA;AAhDR","sourcesContent":["grid-data {\n\n    mat-sidenav-container {\n        width: 100%;\n        height: 100%;\n\n        mat-sidenav {\n            width: 70% !important;\n            min-width: 70% !important;\n            max-width: 70% !important;\n        }\n\n        #board {\n            display: flex;\n            flex-direction: column !important;\n            height: 100%;\n\n            >.header {\n                position: relative;\n                min-height: 72px;\n                height: 72px;\n                background-image: none;\n                z-index: 49;\n\n                .header-content {\n\n                    .header-boards-button {\n                        margin: 0;\n                    }\n\n                    .header-board-name {\n                        font-size: 16px;\n\n                        .board-subscribe {\n                            margin-right: 8px;\n                        }\n\n                        .editable-buttons {\n\n                            mat-icon {\n                                color: #FFFFFF !important;\n                            }\n                        }\n                    }\n\n                    .right-side {\n\n                        >.mat-mdc-button:last-child {\n                            margin-right: 0;\n                        }\n                    }\n\n                }\n\n                .quick-search {\n                    content: \"\";\n                    cursor: pointer;\n                    position: absolute;\n                    top: 100%;\n                    right: 2%;\n                    margin: -10 auto;\n                    width: 0;\n                    height: 0;\n                    border-left: solid 20px transparent;\n                    border-right: solid 20px transparent;\n                    z-index: 1;\n\n                    mat-icon {\n                        &.add {\n                            bottom: 0;\n                            position: absolute;\n                            left: -12px;\n                        }\n\n                        &.minimize {\n                            bottom: 9px;\n                            position: absolute;\n                            left: -12px;\n                        }\n\n                    }\n                }\n\n                accounts-quick-search {\n                    position: absolute;\n                    top: 100%;\n                    width: 100%;\n                    right: 0;\n                }\n\n                owners-quick-search {\n                    position: absolute;\n                    top: 100%;\n                    width: 100%;\n                    right: 0;\n                }\n            }\n\n            #board-selector {\n                position: absolute;\n                top: 96px;\n                right: 0;\n                left: 0;\n                height: 192px;\n                z-index: 48;\n                padding: 24px;\n                opacity: 1;\n\n                .board-list-item {\n                    width: 128px;\n                    height: 192px;\n                    padding: 16px;\n                    cursor: pointer;\n                    position: relative;\n\n                    .board-name {\n                        text-align: center;\n                        padding: 16px 0;\n                    }\n\n                    .selected-icon {\n                        position: absolute;\n                        top: 0;\n                        left: 50%;\n                        width: 32px;\n                        height: 32px;\n                        margin-left: -16px;\n                        border-radius: 50%;\n                        text-align: center;\n                        color: white;\n\n                        i {\n                            line-height: 32px !important;\n                        }\n                    }\n\n                    &.add-new-board {\n                        opacity: 0.6;\n                    }\n                }\n            }\n\n            .board-content-wrapper {\n                position: relative;\n\n                .board-content {\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                    height: 100%;\n                    overflow-y: hidden;\n                    overflow-x: auto;\n                    -webkit-overflow-scrolling: touch;\n\n                    .list-sortable-placeholder {\n                        background: rgba(0, 0, 0, 0.06);\n                        margin-right: 24px;\n                    }\n\n                    .new-list-wrapper {\n                        width: 344px;\n                        min-width: 344px;\n                        max-width: 344px;\n                        padding-right: 24px;\n                    }\n\n                }\n            }\n        }\n    }\n\n    .loading-shade {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.15);\n        z-index: 1000;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .example-container {\n        width: 400px;\n        max-width: 100%;\n        margin: 0 25px 25px 0;\n        display: inline-block;\n        vertical-align: top;\n      }\n      \n      .example-list {\n        border: solid 1px #ccc;\n        min-height: 60px;\n        background: white;\n        border-radius: 4px;\n        overflow: hidden;\n        display: block;\n      }\n      \n      .example-box {\n        padding: 20px 10px;\n        border-bottom: solid 1px #ccc;\n        color: rgba(0, 0, 0, 0.87);\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        box-sizing: border-box;\n        cursor: move;\n        background: white;\n        font-size: 14px;\n      }\n      \n      .cdk-drag-preview {\n        box-sizing: border-box;\n        border-radius: 4px;\n        box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n                    0 8px 10px 1px rgba(0, 0, 0, 0.14),\n                    0 3px 14px 2px rgba(0, 0, 0, 0.12);\n      }\n      \n      .cdk-drag-placeholder {\n        opacity: 0;\n      }\n      \n      .cdk-drag-animating {\n        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n      }\n      \n      .example-box:last-child {\n        border: none;\n      }\n      \n      .example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\n        transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n      }\n      \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
